import { render, staticRenderFns } from "./intersection-anchor.vue?vue&type=template&id=7ff7859c"
import script from "./intersection-anchor.vue?vue&type=script&lang=js"
export * from "./intersection-anchor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports